import T from '../types';

const resetSuggest = slug => ({
  type: T.SUGGEST_RESET,
  slug,
});

export default resetSuggest;
